import { VNode } from 'preact';
import { toIconElement } from '@accedo/ctv-ui-icons';
import search from '@accedo/ctv-ui-icons/assets/cta-all-to-actions/search.svg';
import home from '@accedo/ctv-ui-icons/assets/app-navigation/home.svg';
import movies from '@accedo/ctv-ui-icons/assets/app-navigation/movies.svg';
import series from '@accedo/ctv-ui-icons/assets/app-navigation/series.svg';
import AddPlusSvg from '@accedo/ctv-ui-icons/assets/cta-all-to-actions/add-plus.svg';
import TvGuideSvg from '@accedo/ctv-ui-icons/assets/app-navigation/tv-guide.svg';
import settings from '@accedo/ctv-ui-icons/assets/user/settings/style-outlined.svg';

const MenuIconsByLabel: { [key: string]: string } = {
  'icon/home': `${home}#home`,
  'icon/film-nzos-plus': `${movies}#movies`,
  'icon/short-film': `${series}#series`,
  'icon/tv': `${TvGuideSvg}#tv-guide`,
  'icon/plus-symbol': `${AddPlusSvg}#add-plus`,
  'icon/search': `${search}#search`,
  'icon/settings': `${settings}#style-outlined`,
};

const getIconByViaLabel = (src: string): VNode<Element> => {
  const baseIcon = MenuIconsByLabel[src];

  return toIconElement(baseIcon, { attributes: { width: 32, height: 36, viewBox: '0 0 24 24' } });
};

export { getIconByViaLabel };
